import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

export class SavePage {
    private $savePdfButton: JQuery;
    private $printPageButton: JQuery;
    private $mainContent: JQuery;

    public constructor(savePdfButton: JQuery, printPageButton: JQuery, mainContent: JQuery) {
        this.$savePdfButton = savePdfButton;
        this.$printPageButton = printPageButton;
        this.$mainContent = mainContent;

        this.bindEvents();
    }

    private bindEvents(): void {
        this.$savePdfButton.on("click", (e) => {
            e.preventDefault();
            this.savePageAsPdf();
        });
        this.$printPageButton.on("click", (e) => {
            e.preventDefault();
            this.printPage();
        });
    }

    private savePageAsPdf(): void {
        html2canvas(this.$mainContent[0], {
            scrollX: 0,
            scrollY: -window.scrollY
        }).then(canvas => {
            const pdf = new jsPDF({
                orientation: "p",
                unit: "px",
                format: [canvas.width, canvas.height]
            });

            const imgData = canvas.toDataURL("image/png");
            pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);

            const url = window.location.hostname;
            const now = new Date();
            const datetime = now.toISOString().replace(/:/g, "-");
            const filename = `${url}_${datetime}.pdf`;
            pdf.save(filename);
        }).catch(error => {
            console.error("Error capturing content:", error);
        });
    }
    private printPage(): void {
        window.print();
    }

    public static init(savePdfButton: JQuery, printPageButton: JQuery, mainContent: JQuery): void {
        new SavePage(savePdfButton, printPageButton, mainContent);
    }
}
